import { createFileRoute } from '@tanstack/react-router';
import { ProfileBonusesPage } from './-components/ProfileBonusesPage';

export const Route = createFileRoute('/profile/bonuses/')({
  component: ProfileBonusesPage,
});
